import { Schema } from "effect";
import { StationId } from "@workerstation/shared/station-id";
import { ChatConfigResponse, ChatTailResponse, ChatThreadSummary as SharedChatThreadSummary, ChatMessageRequest, ChatApprovalDecisionResponse, ChatProposalOutcomeRow } from "@workerstation/shared/chat-contract";
import { WorktreeResponses } from "@workerstation/shared/station/worktree";
import type { ResourceStorageError } from "@workerstation/shared/errors/resource";
export const ChatStation = Schema.Struct({ stationId: StationId });
export type ChatStation = typeof ChatStation.Type;
export const ChatThread = Schema.Struct({ ...ChatStation.fields, threadId: Schema.String });
export type ChatThread = typeof ChatThread.Type;
export const ChatProposal = Schema.Struct({ ...ChatThread.fields, proposalId: Schema.String });
export type ChatProposal = typeof ChatProposal.Type;
export const ChatReview = Schema.Struct({ ...ChatProposal.fields, worktreeId: Schema.String });
export type ChatReview = typeof ChatReview.Type;
/** A decoded refusal from this browser client's declared public HTTP surface. */
export const ChatClientRequestError = /* @__PURE__ */ (() => {
  class ChatClientRequestError extends Schema.TaggedError<ChatClientRequestError>()("ChatClientRequestError", {
    status: Schema.Literals([400, 404, 409, 413, 429, 503]), message: Schema.String
  }) {}
  return ChatClientRequestError;
})();
export type ChatClientRequestError = InstanceType<typeof ChatClientRequestError>;
export type ChatClientFailure = ChatClientRequestError | ResourceStorageError;
export type ChatConfiguration = typeof ChatConfigResponse.Type;
export type ChatTail = typeof ChatTailResponse.Type;
export type ChatThreadSummary = typeof SharedChatThreadSummary.Type;
export type ChatMessage = typeof ChatMessageRequest.Type;
export type ChatApprovalDecision = typeof ChatApprovalDecisionResponse.Type;
export const ChatConfigurationPatch = Schema.Struct({ model: Schema.optionalKey(Schema.String), yolo: Schema.optionalKey(Schema.Boolean) });
export type ChatConfigurationPatch = typeof ChatConfigurationPatch.Type;
export type ChatProposalOutcome = { readonly outcome: typeof ChatProposalOutcomeRow.fields.outcome.Type; readonly detail?: typeof ChatProposalOutcomeRow.fields.detail.Type };
export type ChatProposalReview = typeof WorktreeResponses["worktree.diff"]["Type"];
export const ChatCursor = Schema.Struct({ ...ChatThread.fields, afterSequence: Schema.String });
export type ChatCursor = typeof ChatCursor.Type;

/** Explicit legacy acknowledgement retained by the native frontend. Optional
 * authoritative fields are validated whenever present; none are fabricated. */
export const LegacyChatApproval = Schema.Struct({
  ok: Schema.Literal(true), resumed: Schema.optionalKey(Schema.Boolean),
  turnActive: Schema.optionalKey(Schema.Boolean), replayed: Schema.optionalKey(Schema.Boolean)
});
export const ChatApprovalResult = Schema.Union([
  Schema.Struct({ _tag: Schema.Literal("Current"), response: ChatApprovalDecisionResponse }),
  Schema.Struct({ _tag: Schema.Literal("Legacy"), response: LegacyChatApproval })
]);
export type ChatApprovalResult = typeof ChatApprovalResult.Type;
